// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html


import {
  SubscriptionsPage,
  SubscribePage,
  CheckoutPage,
  FeatureHub,
  PaymentDetailsPage
} from './';

export default {
  path: 'subscriptions',
  childRoutes: [
    { path: '', component: SubscriptionsPage, isIndex: true },
    { path: 'subscribe', component: SubscribePage },
    { path: 'checkout', component: CheckoutPage },
    { path: 'features', component: FeatureHub },
    { path: 'features/:tabId', component: FeatureHub },
    { path: 'payment', component: PaymentDetailsPage },
  ],
};
